import { SEGMENTOS, SEGMENTOS_BARRA } from "./segmentos";

/**
 * Navegación.
 *
 * El sitio vende dos cosas — eventos y fotos en estudio — y las dos van en la
 * barra con su nombre. "Precios" va primero porque el precio publicado es el
 * argumento del sitio: el precio a la vista, sin cotizar.
 *
 * /sobre-omega se etiqueta "Nosotros" y no "El estudio" para que no se
 * confunda con el servicio de fotos en estudio, que está al lado.
 */

export const NAV_LINKS = [
  { to: "/precios", label: "Precios" },
  ...SEGMENTOS_BARRA.map((segmento) => ({ to: segmento.path, label: segmento.nombreCorto })),
  { to: "/portafolio", label: "Portafolio" },
  { to: "/sobre-omega", label: "Nosotros" },
];

/** CTA permanente del header y de la barra móvil. */
export const NAV_CTA = { to: "/precios", label: "Ver precios" };

/** Los servicios para el footer, en su orden de aparición. Aquí sí entran
    las páginas de búsqueda: el footer es el enlace interno que llega a todas. */
export const FOOTER_SEGMENTOS = SEGMENTOS.map((segmento) => ({
  to: segmento.path,
  label: segmento.nombre,
}));

export const FOOTER_SITIO = [
  { to: "/precios", label: "Precios" },
  { to: "/portafolio", label: "Portafolio" },
  { to: "/sobre-omega", label: "Nosotros" },
  { to: "/contacto", label: "Contacto" },
];
